export default __webpack_public_path__ + "static/media/2460.1786e8b6.png";